<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wDQRtE/tc-custom/9781524865184.jpg?1730635463189" alt="This image is the cover for the book LEWSER!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">LEWSER!
      </h1>
      <p class="bookDescription body article font2">
        <b>Following <i>YUGE!</i> and <i>#SAD!</i>, volume three of the Doonesbury Trump Trilogy chronicles the disrupter-in-chief’s massive output of grievance and fear.</b><br/><br/>From the Pulitzer Prize–winning cartoonist whose acclaimed <i>YUGE!: 30 Years of Doonesbury on Trump</i> blew up the bestseller list, G. B. Trudeau’s final installment of his Doonesbury Trump Trilogy takes readers through the dark heart of Trump’s presidency and into 2020 election mania. Including two years’ worth of original <i>Doonesbury</i> Sundays, full-color spreads, and eighteen previously unpublished strips, the presciently-titled <i>LEWSER!</i> chronicles our most recent—and apparently never-ending—national nightmare.<br/><br/><b>“When historians look back on this era, <i>Doonesbury</i> will be as good a record as any of the national zeitgeist.” —<i>Rolling Stone</i></b><br/><br/><b>“Why so surprised America? <i>Doonesbury</i> has been preparing us for President Trump since 1987.” —<i>USA Today</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        G. B. Trudeau
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18f1fb76